module.exports = __webpack_public_path__ + "img/csv-file.6c05a062.svg";